import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaPhoneAlt, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../images/logo-2.png';
import './Navbar.css';

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const location = useLocation(); // Get current URL

    // Define paths where the navbar should be hidden
    const hiddenPaths = ["/estimation-offerte"];

    // If the current path is in the hiddenPaths array, don't render the navbar
    if (hiddenPaths.includes(location.pathname)) {
        return null;
    }

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleSubMenu = () => {
        setIsSubMenuOpen(!isSubMenuOpen);
    };

    return (
        <nav className="navbar">
            <Link to="/" className="logo-link">
                <img src={logo} alt="Antiquaire Paris Logo" className="logo" />
            </Link>

            <div className="menu-toggle" onClick={toggleMenu}>
                {isMenuOpen ? <FaTimes /> : <FaBars />}
            </div>

            <a href="tel:+0658084516" className="phone-number">
                <FaPhoneAlt className="phone-icon" />
                06 58 08 45 16
            </a>

            <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Accueil</Link></li>
                <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>À Propos</Link></li>
                <li><Link to="/objets" onClick={() => setIsMenuOpen(false)}>Objets</Link></li>
                <li><Link to="/services" onClick={() => setIsMenuOpen(false)}>Services</Link></li>

                <li
                    className="has-submenu"
                    onMouseEnter={() => setIsSubMenuOpen(true)}
                    onMouseLeave={() => setIsSubMenuOpen(false)}
                >
                    <Link to="/zone-d-intervention" onClick={() => setIsMenuOpen(false)}>Zones d'Intervention</Link>
                    <ul className={`submenu ${isSubMenuOpen ? 'open' : ''}`}>
                        {[
                            { path: '/zone-d-intervention/77', label: '77' },
                            { path: '/zone-d-intervention/93', label: '93' },
                            { path: '/zone-d-intervention/94', label: '94' },
                            { path: '/zone-d-intervention/91', label: '91' },
                            { path: '/zone-d-intervention/78', label: '78' },
                            { path: '/zone-d-intervention/75', label: '75' },
                        ].map((zone, index) => (
                            <li key={index}>
                                <Link to={zone.path} onClick={() => setIsMenuOpen(false)}>{zone.label}</Link>
                            </li>
                        ))}
                    </ul>
                </li>

                <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
            </ul>
        </nav>
    );
}

export default Navbar;
